var pug = require("!../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (data) {pug_mixins["urlLink"] = pug_interp = function(url, displayText){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (url.indexOf('http') !== 0) {
url='http://'+url
}
pug_html = pug_html + "\u003Ca" + (pug.attr("href", url, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = displayText) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
};
pug_mixins["sitelink"] = pug_interp = function(link){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cli\u003E";
if (link.DestinationUrl) {
pug_mixins["urlLink"](link.DestinationUrl, link.DisplayText);
}
else
if (link.FinalUrls && link.FinalUrls.length>0) {
pug_mixins["urlLink"](link.FinalUrls[0], link.DisplayText);
}
if (link.Description1) {
pug_html = pug_html + "\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = link.Description1) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (link.Description2) {
pug_html = pug_html + "\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = link.Description2) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"itemTemplate-text\"\u003E\u003Cul\u003E";
if (data.SiteLinks) {
// iterate data.SiteLinks
;(function(){
  var $$obj = data.SiteLinks;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var link = $$obj[pug_index0];
pug_mixins["sitelink"](link);
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var link = $$obj[pug_index0];
pug_mixins["sitelink"](link);
    }
  }
}).call(this);

}
else {
pug_mixins["sitelink"](data);
}
pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";}.call(this,"data" in locals_for_with?locals_for_with.data:typeof data!=="undefined"?data:undefined));;return pug_html;};
module.exports = template;